// import { Suspense, useEffect, useState } from 'react'
// import { Outlet, useLocation } from 'react-router-dom'
// import Loader from '../components/Loader'

// const Rootlayout = () => {
//     const [showOverlay, setShowOverlay] = useState(false);
//     const [landscapeMode, setLandscapeMode] = useState(false);
//     const { pathname } = useLocation();

//     useEffect(() => {
//         const handleResize = () => {
//             if (window.innerWidth <= 600) {
//                 setShowOverlay(true);
//             } else {
//                 setShowOverlay(false);
//                 setLandscapeMode(false);
//             }
//         };

//         handleResize();
//         window.addEventListener('resize', handleResize);
//         return () => window.removeEventListener('resize', handleResize);
//     }, []);

//     function continueWithLandscape() {
//         setShowOverlay(false);
//         setLandscapeMode(true);
//     }

//     function continueWithoutLandscape() {
//         setShowOverlay(false);
//         setLandscapeMode(false);
//     }

//     return (
//         <Suspense fallback={<Loader />}>
//             {showOverlay && pathname !== '/' && (
//                 <Overlay
//                     continueWithLandscape={continueWithLandscape}
//                     continueWithoutLandscape={continueWithoutLandscape}
//                 />
//             )}


//             <div className="fixed top-0 left-0 w-screen h-screen overflow-hidden bg-black z-30">
//                 {landscapeMode ? (
//                     <div
//                         className="absolute top-1/2 left-1/2"
//                         style={{
//                             transform: 'translate(-50%, -50%) rotate(90deg)',
//                             width: window.innerHeight,
//                             height: window.innerWidth,
//                             overflowY: 'auto',
//                             overflowX: 'hidden',
//                         }}
//                     >
//                         <Outlet />
//                     </div>
//                 ) : (
//                     <div className="w-full h-full overflow-y-auto overflow-x-hidden">
//                         <Outlet />
//                     </div>
//                 )}
//             </div>
//         </Suspense>
//     );
// };

// function Overlay({ continueWithLandscape, continueWithoutLandscape }) {
//     return (
//         <div className="backdrop-blur-lg fixed top-0 left-0 w-full h-full z-50 flex flex-col justify-center items-center gap-4">
//             <button className="bg-primary px-6 py-2 rounded" onClick={continueWithLandscape}>
//                 Continue with the landscape mode
//             </button>
//             <button className="bg-primary px-6 py-2 rounded" onClick={continueWithoutLandscape}>
//                 Continue without the landscape mode
//             </button>
//         </div>
//     );
// }

// export default Rootlayout;


import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import Loader from '../components/Loader'

const Rootlayout = () => {


    return (
        <Suspense fallback={<Loader />}>
            <div className="w-full h-screen  overflow-x-hidden">
                <Outlet />
            </div>
            {/* <Outlet /> */}
        </Suspense>
    );
};


export default Rootlayout;
